module.exports = __webpack_public_path__ + "63f722d8b7768a7d852c454e7dfbf833.png";